export class ImportJsonRequest {
   base64content: string;
   filename: string;

   constructor(b64Content: string, filename: string) {
      this.base64content = b64Content;
      this.filename = filename;
   }
}